import styled from 'styled-components';

export const StyledVoiceSelectionDialog = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;

  .loading-container {
    display: flex;
    justify-content: center;
  }
`;

export const StyledVoiceSelectionDialogTitle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;
